import templateMarkup from 'raw-loader!./dashboard-view.template.html';
import DialBackInput from '../../../../components/dialBackInput/dialBackInput.ko'; // not used here but needed for template
import DateRangeModel from '../../../../components/dialBackInput/date-range-picker.model';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import '../../../../components/tabbed-dashboard/tabbed-dashboard';

function DashboardView(params) {
    var self = this;
    self.route = params.route;
    self.routeParams = ko.unwrap(_.get(params, 'routeParams'));
    self.appId = _.get(self, 'routeParams.appId', 'app');
    self.captureType = _.get(self, 'routeParams.type', 'page');
    self.pageId = _.get(self, 'routeParams.pageId', 'dashboard');
    self.title = _.get(self, 'routeParams.title', 'Dashboard');
    self.viewId = _.get(self, 'routeParams.viewId', 'dashboard');
    self.menus = params.menus;
    self.dateRangeModel = ko.observable(new DateRangeModel(self.appId));
}

// this component is directly registered at 'src/app/component-registration.js'
// since it is needed long before its parent module is loaded
export default { template: templateMarkup, viewModel: DashboardView };
